// extracted by mini-css-extract-plugin
export default {"bannersContainer":"Banner_bannersContainer__lKkQj","banner":"Banner_banner__LGb+O","removeButton":"Banner_removeButton__kNWCX"};